import { GenericNotificationProps } from '@msc-b2c/interfaces/types';
import styles from './genericnotification.module.scss';
import { Text } from '../text/Text';
import { Icon } from '../icons/Icon';
import { Button } from '../button/Button';
import { useEffect, useRef, useState } from 'react';

export function GenericNotification({
  onClose,
  bannerTitle,
  bannerIcon,
  bannerBackgroundColor,
  bannerDescription,
  bannerTextColor,
  bannerButtonLabel,
  bannerButtonLink,
  onButtonClick,
  isNegativeButton = false,
  bannerClose,
  genericNotificationIconAriaLabel = '',
}: Readonly<GenericNotificationProps>) {
  const [isVisible, setIsVisible] = useState(true);
  const bannerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (bannerRef.current) {
      bannerRef.current.focus();
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    isVisible && (
      <div
        ref={bannerRef}
        tabIndex={-1}
        role="alert"
        aria-live="assertive"
        className={styles['genericNotification']}
        style={{ backgroundColor: bannerBackgroundColor, color: bannerTextColor || 'inherit' }}
      >
        <div
          className={styles['genericNotification--main']}
          style={{ backgroundColor: bannerBackgroundColor, color: bannerTextColor || 'inherit' }}
        >
          <Icon
            ariaHidden={true}
            icon={bannerIcon}
            styleOption={styles['genericNotification--icon']}
          />
          <div className={styles['textContainer']}>
            <Text
              text={bannerTitle}
              styleOption={styles['textContainer--title']}
            />
            <Text
              text={bannerDescription}
              styleOption={styles['textContainer--description']}
            />
            {bannerButtonLabel && (onButtonClick || bannerButtonLink) && (
              <Button
                styleOption={`${
                  isNegativeButton
                    ? 'cmp-button__secondary cmp-button__negative'
                    : 'cmp-button__secondary'
                }`}
                buttonLink={onButtonClick ? undefined : { url: bannerButtonLink }}
                text={bannerButtonLabel}
                accessibilityLabel={bannerButtonLabel}
                onClick={onButtonClick}
              ></Button>
            )}
          </div>
        </div>
        {bannerClose && (
          <Icon
            icon={bannerClose}
            styleOption={styles['genericNotification--icon']}
            ariaLabel={genericNotificationIconAriaLabel}
            onClick={handleClose}
          />
        )}
      </div>
    )
  );
}
